export default () => ({
	type: 'REMOVE_USER'
})
